<template>
  <div class="home">
    <div class="header">
      <div class="header-texts">
        <h1>Софтуерна</h1>
        <h1>инженерингова компания</h1>
        <div class="row">
          <div class="video" @click="isModalOpened = true">
            <img src="/static/img/home/thumb.webp" />
            <p>
              <strong>Представяне от управителя</strong>
            </p>
            <p>Кратко представяне на фирма Си Дотс от нейния управител, за създаването до сега</p>
          </div>
          <div class="header-ps">
            <p>Създаваме програми за управление на производство, машини и съоръжения. Системите ни изчисляват натовареността на персонала, калкулират заработки, надници и капацитет на машини и служители.</p>
            <p>Увеличаваме ефективността и мощностите на предприятието. Изчистваме административните затруднения и неработещи процеси.</p>
            <p>Екип от инженери работещи за малките и средни предприятия в страната.</p>
          </div>
        </div>
      </div>
      <img class="header-img" src="/static/img/home/header.webp" alt="Preview" />
    </div>
    <div class="solutions" id="solutions">
      <div class="solutions-header">
        <h6 @click="isMenuHidden = false">
          НАШИТЕ РЕШЕНИЯ
          <svg
            class="arrow"
            :class="{ 'arrow-rotated' : !isMenuHidden }"
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 59.4 59.4"
            style="enable-background:new 0 0 59.4 59.4;"
            xml:space="preserve"
          >
            <g>
              <polygon points="29.7,45.3 0,15.6 1.4,14.1 29.7,42.4 58,14.1 59.4,15.6 	" />
            </g>
          </svg>
        </h6>
        <div class="solutions-header-content">
          <!-- active-class is not working on 'back', so I've bind the class after url params check -->
          <!-- it's a little bit more code but it is working -->
          <router-link
            to="/industrial"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'industrial', 'solutions-header-item-hidden' : isMenuHidden }"
          >Индустриални</router-link>
          <router-link
            to="/administrative"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'administrative', 'solutions-header-item-hidden' : isMenuHidden }"
          >Административни</router-link>
          <router-link
            to="/trade"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'trade', 'solutions-header-item-hidden' : isMenuHidden }"
          >Търговия</router-link>
          <router-link
            to="/financial"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'financial', 'solutions-header-item-hidden' : isMenuHidden }"
          >Финансови</router-link>
          <router-link
            to="/business"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'business', 'solutions-header-item-hidden' : isMenuHidden }"
          >Бизнес</router-link>
           <router-link
            to="/medicine"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'medicine', 'solutions-header-item-hidden' : isMenuHidden }"
          >Медицина</router-link>
          <!-- <router-link
            to="/e-commerce"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'medicine', 'solutions-header-item-hidden' : isMenuHidden }"
          >Медицина</router-link> -->
          <router-link
            to="/integration"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'integration', 'solutions-header-item-hidden' : isMenuHidden }"
          >Интеграция</router-link>
          <router-link
            to="/others"
            class="solutions-header-item"
            :class="{ 'solutions-header-item-active' : this.$route.params.category === 'others', 'solutions-header-item-hidden' : isMenuHidden }"
          >Други</router-link>
        </div>
      </div>
      <div class="solutions-content" v-if="solutions.length">
        <router-link
          class="solutions-item"
          v-for="(solution, index) in solutions"
          :key="'solution-' + index"
          :to="solution.isNotSolution ? `/${solution.url}` : `/${solution.category}/${solution.url}`"
        >
          <img class="solutions-item-img" :src="solution.imageOne" alt="Image" />
          <p class="solutions-item-description">{{solution.name[0]}}</p>
          <span class="solutions-item-name" v-if="solution.company">{{solution.company}}</span>
        </router-link>
      </div>
      
      <!-- <div
        class="solutions-content"
        v-else-if="!solutions.length && this.$route.params.category === 'e-commerce'"
      >
        <div class="solutions-content-itemless">
          <img src="/static/img/solutions/6.webp" alt="cDots" />
          <div class="solutions-content-itemless-texts">
            <p>Е-магазин за къмпингово оборудване и свързаните с това продукти, интеграция на всички видове плащания, включително лизинг на оборудване.</p>
            <p>Е-магазин за едра и дребна бяла техника, електроника за няколко държави – България, Гърция, Словения, Македония. Системата е интегрирана и се управлява от едно място, централизирано.</p>
            <p>Е-магазин за бетонови елементи – при поръчка изчислява стойността на доставката за клиента, на поръчаните елементи.</p>
          </div>
        </div>
      </div> -->
      <div
        class="solutions-content"
        v-else-if="!solutions.length && this.$route.params.category === 'integration'"
      >
        <div class="solutions-content-itemless">
          <img src="/static/img/solutions/cd2.webp" alt="cDots" />
          <div class="solutions-content-itemless-texts">
            <p><strong>Интеграции с външни системи</strong></p>
            <p>➡️ Интеграция на вътрешни системи – Комуникационна инфраструктура (мейл, чат, календари, споделени работни пространства), клауд решение за управление и споделяне на файлове, хелпдеск система.</p>
            <p>➡️ Клауд базирани системи - за различни бизнес решения</p>
            <p>➡️ Интеграция на ERP система с модул за мобилни продажби</p>
            <p>➡️ Интеграция на ERP система с е-магазин</p>
            <p>➡️ Интеграция на ERP система с решение за справки (reporting tool)</p>
            <p>➡️ Интеграция на мобилни приложения с вътрешни системи (GPS проследяване и други)</p>
          </div>
        </div>
      </div>
      <div
        class="solutions-content"
        v-else-if="!solutions.length && this.$route.params.category === 'others'"
      >
        <div class="solutions-content-itemless">
          <img src="/static/img/solutions/9.webp" alt="cDots" />
          <div class="solutions-content-itemless-texts">
            <p> <strong>Одит на ИТ активи с структурата на Министерство на Земеделието, Храните и Горите (МЗХГ)</strong> </p>
            <ul>
              <p>➡️ Преглед на активни договори за ИТ активи обслужвани към дирекция „Информационно и комуникационно обслужване“</p>
              <p>➡️ Анализ на ползвани решения към момента на одита, решения в процес на закупуване и разработка, планирани решения.</p>
              <p>➡️ Анализ на решения за информационна сигурност</p>
              <p>➡️ Анализ на рентабилност на договори, доставчици и закупени ИТ активи</p>
            </ul>
          </div>
        </div> <br>
        <div class="solutions-content-itemless">
          <img src="/static/img/solutions/8.webp" alt="cDots" />
          <div class="solutions-content-itemless-texts">
            <p><strong>Други решения на cDots</strong></p>
            <p>➡️ Система за отчитане на маркетингови ефекти – фармацевтична компания</p>
            <p>➡️ Система за управление добивите от открита мина – миннодобивна компания</p>
            <p>➡️ Система за следене натоварването на служители – административна структура</p>
            <p>➡️ Система за контрол действията на потребителите при работа с компютър – финансова институция</p>
            <p>➡️ Система за реален мониторинг натоварването на производствени мощности – производствена компания, хранителен сектор</p>
            <p>➡️ Система за управление на бързи кредити и превенция срещу кражби (схеми) на кредити – небанкова институция.</p>
          </div> 
        </div><br> <br>
         <div class="solutions-content-itemless">
          <img src="/static/img/solutions/cd2.webp" alt="cDots" />
          <div class="solutions-content-itemless-texts">
            <p><strong>Специализирана администрация</strong></p>
            <p>➡️ Ограничаване права на компютри</p>
            <p>➡️ Следенe активност на компютър</p>
            <p>➡️ Записване на действия от работа с компютър</p>
            <p>➡️ Права за ползване на определени файлове и папки от файлов сървър</p>
            <p>➡️ Оптимизация на стари/бавни компютри и администрация</p>
            <p>➡️ Настройка и сигурност за работа с отдалечен достъп и информация</p>
          </div>
        </div> <br><br> <br>
      </div>
      <div class="solutions-content" v-else>
        <p class="no-solutions">Няма решения в избраната категория</p>
      </div>
    </div>
    <Consultation />
    <transition name="fade">
      <Modal v-if="isModalOpened" :video="'https://www.youtube.com/embed/9lgpbgo4GdM'" />
    </transition>
  </div>
</template>

<script>
import Solutions from '../assets/solutions.json';
import Consultation from './Consultation';
import Modal from './shared/Modal';
export default {
  components: {
    Consultation: Consultation,
    Modal: Modal
  },
  data() {
    return {
      solutions: Solutions,
      isMenuHidden: true,
      isModalOpened: false
    };
  },
  watch: {
    $route(to, from) {
      this.filterSolutions();
      this.isMenuHidden = true;
    }
  },
  methods: {
    filterSolutions() {
      if (this.$route.name === 'HomeCategorySelected') {
        const category = this.$route.params.category;
        this.solutions = Solutions.filter(o => {
          return o.category === category;
        });
      } else {
        this.solutions = Solutions;
      }
    }
  },
  mounted() {
    this.filterSolutions();
    this.$on('close-modal', () => (this.isModalOpened = false));
  },
  destroyed() {
    this.$off('close-modal');
  }
};
</script>

<style scoped>
.home {
  overflow: hidden;
}
/* HEADER */
.header {
  align-items: center;
  display: flex;
  padding-left: 100px;
  padding-right: 100px;
  padding-top: 40px;
  position: relative;
  width: 100%;
}
.header-texts {
  width: 70%;
}
.row {
  display: flex;
  width: 90%;
}
.header-texts > h1:last-of-type {
  margin-bottom: 30px;
}
.header-ps {
  width: 50%;
}
.header-ps > p {
  margin-bottom: 15px;
  /* width: 90%; */
}
.header-ps > p:last-child {
  margin-bottom: 0;
}
.header-img {
  max-width: 1000px;
  position: absolute;
  right: -10%;
  top: 50px;
  width: 50%;
  z-index: -1;
}
/* SOLUTIONS */
.solutions {
  align-items: center;
  display: flex;
  flex-direction: column;
}
.solutions-header > h6 {
  font-weight: 500;
  margin: 30px 0;
  text-align: center;
}
.solutions-header-content {
  display: flex;
}
.solutions-header-item {
  align-items: center;
  background-color: #f8f8f8;
  border-radius: 4px;
  color: #3f3f3f;
  cursor: pointer;
  display: inline-flex;
  height: 90px;
  justify-content: center;
  margin-right: 20px;
  padding: 20px;
  text-align: center;
  width: 160px;
}
.solutions-header-item:last-of-type {
  margin: 0;
}
.solutions-header-item:hover {
  background-color: #ebebeb;
}
.solutions-header-item-active {
  background-color: #d9d9d9;
}
.inactive {
  cursor: default;
}
.inactive:hover {
  background-color: #f8f8f8;
}
/* SOLUTION ITEMS */
.solutions-content {
  display: flex;
  flex-wrap: wrap;
  padding: 75px 0;
  width: 1300px;
}
.solutions-item {
  width: 400px;
  margin-right: 50px;
  margin-bottom: 40px;
}
.solutions-item:nth-of-type(3n) {
  margin-right: 0;
}
.solutions-item-img {
  border-radius: 15px;
  width: 100%;
}
.solutions-item-description {
  color: #000;
  margin: 15px 0 5px;
}
.solutions-item-name {
  color: #929292;
  font-size: 14px;
}
.solutions-content-itemless {
  align-items: center;
  display: flex;
}
.solutions-content-itemless img {
  margin-right: 3%;
  width: 37%;
}
.solutions-content-itemless-texts {
  margin-left: 3%;
  width: 57%;
}
.solutions-content-itemless-texts p {
  margin-bottom: 15px;
}
.no-solutions {
  opacity: 0.6;
  text-align: center;
  width: 100%;
}
.arrow {
  display: none;
}
/* RESPONSIVE */
@media screen and (max-width: 1600px) {
  .header-texts > h1:last-of-type {
    margin-bottom: 25px;
  }
  .solutions-header-item {
    font-size: 14px;
    width: 150px;
  }
  .solutions-header-content {
    width: 1200px;
  }
  .solutions-content {
    padding: 60px 0;
    width: 1120px;
  }
  .solutions-item {
    width: 340px;
  }
  .header-ps {
    width: 60%;
  }
}
@media screen and (max-width: 1440px) {
  .header {
    padding: 30px 100px;
  }
  .header-texts > h1:last-of-type {
    margin-bottom: 20px;
  }
}
@media screen and (max-width: 1366px) {
  .solutions-header > h6 {
    margin: 25px 0;
  }
  .solutions-header-item {
    font-size: 12px;
    height: 75px;
    width: 150px;
  }
  .solutions-header-content {
    width: 1100px;
  }
  .solutions-content {
    padding: 40px 0;
    width: 1000px;
  }
  .solutions-item {
    width: 300px;
  }
  .solutions-item-description {
    font-size: 13px;
    margin: 10px 0 0px;
  }
  .solutions-item-name {
    font-size: 12px;
  }
}
@media screen and (max-width: 1280px) {
  .header-img {
    display: none;
  }
  .header {
    padding: 20px;
  }
  .row {
    align-items: center;
    flex-direction: column-reverse;
    width: 100%;
  }
  .header-texts {
    width: 100%;
  }
  .header-texts h1 {
    text-align: center;
  }
  .header-ps {
    width: 100%;
  }
  .header-ps p {
    text-align: center;
    width: 100%;
  }
  .header-texts > h1:last-of-type {
    margin-bottom: 10px;
  }
  .solutions-header {
    width: 100%;
    padding: 0 20px;
  }
  .solutions-header-content {
    width: 100%;
  }
  .solutions-header-item {
    width: 12.5%;
  }
  .solutions-content {
    padding: 20px;
    width: 100%;
  }
  .solutions-item {
    width: calc(33.33% - 13.33px);
    margin-right: 20px;
  }
}
@media screen and (max-width: 1000px) {
  .solutions {
    padding-bottom: 63px;
  }
  .solutions-header-content {
    flex-wrap: wrap;
  }
  .solutions-header-item {
    height: 50px;
    margin-right: 20px;
    width: calc(25% - 15px);
  }
  .solutions-header-item:nth-child(4n) {
    margin-right: 0;
  }
  .solutions-header-item:nth-child(n + 5) {
    margin-top: 20px;
  }
  .solutions-content {
    padding: 20px 40px;
  }
  .solutions-content-itemless {
    flex-direction: column;
  }
  .solutions-content-itemless img {
    width: 60%;
    margin: 0 0 15px;
  }
  .solutions-content-itemless-texts {
    margin: 15px 0 0;
    width: 100%;
  }
  .solutions-content-itemless-texts p {
    text-align: center;
  }
}
@media screen and (max-width: 800px) {
  .header {
    padding-top: 0;
  }
  .solutions-item {
    margin-bottom: 20px;
    width: calc(50% - 10px);
  }
  .solutions-item:nth-of-type(3n) {
    margin-right: 20px;
  }
  .solutions-item:nth-of-type(2n) {
    margin-right: 0;
  }
}
@media screen and (max-width: 600px) {
  .solutions {
    padding-bottom: 50px;
  }
  .solutions-header > h6 {
    cursor: pointer;
    margin: 0;
    padding: 25px;
  }
  .solutions-header-item {
    margin: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }
  .solutions-header-item:nth-child(n + 5) {
    margin: 0;
  }
  .solutions-header-item-hidden {
    height: 0px;
    padding: 0;
  }
  .solutions-item {
    width: 100%;
    margin: 0 0 20px;
  }
  .solutions-item:nth-of-type(3n) {
    margin-right: 0;
  }
  .solutions-content {
    padding: 20px;
  }
  .solutions-header > h6 {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .arrow {
    display: inline-block;
    height: 16px;
    margin-left: 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 16px;
  }
  .arrow-rotated {
    transform: rotate(180deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue